import { PropsWithoutRef } from 'react'

import Icon from '@ant-design/icons'
import { IconBaseProps } from '@ant-design/icons/lib/components/Icon'

import { SizeSvg } from './NeSizeSvg'

export const NeSizeIcon = (props: PropsWithoutRef<IconBaseProps>) => {
  return <Icon component={SizeSvg} {...props} />
}
